export default __webpack_public_path__ + "static/jason-5b2dd11be79cb9153399d042862206ec.png";